import { Result } from '../../../../common/models/Result';
import { HttpServiceBase } from '../../../../common/services/HttpServiceBase';

export class SendNewOrderRecipeFileService extends HttpServiceBase {

    handle = (input: SendNewOrderRecipeFileServiceInput): Promise<Result<SendNewOrderRecipeFileServiceOutput>|null> => {
        const promise = this.http.post<Result<SendNewOrderRecipeFileServiceOutput>, FormData>(
          `${this.baseUrlFileRepositoryApi}/order-recipe/new`, input.formData, true);
        return promise;
    }
}

export class SendNewOrderRecipeFileServiceInput {
  orderId: number;
  recipeId: number;
  formData: FormData;
}

export class SendNewOrderRecipeFileServiceOutput {
  value: string;
}